module.exports = __webpack_public_path__ + "img/approval.0bdb3266.svg";